var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreateSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.1 16.9V11c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v5.9H11c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h5.9V25c0 .6.5 1.1 1.1 1.1.3 0 .6-.1.8-.3.2-.2.3-.5.3-.8v-5.9H25c.3 0 .6-.1.8-.3.2-.2.3-.5.3-.8 0-.6-.5-1.1-1.1-1.1h-5.9z"
  })));
}

export default SvgCreateSession;